export const Coupon = (params) => {
    const coupon = params.coupon;
    return (
        <>
            <div class="coupon-widget">
                <a href="#" class="coupon-top">
                    <span class="coupon-link-icon"></span>
                    <h3>{coupon.detail}</h3>
                    <div class="coupon-valid-untill">Expires {coupon.expire}</div>
                    <div class="coupon-how-to-use"><strong>How to use?</strong> Just show us this coupon on a screen of your smartphone!</div>
                </a>
                <div class="coupon-bottom">
                    <div class="coupon-scissors-icon"></div>
                    <div class="coupon-code">{coupon.code}</div>
                </div>
            </div>
        </>
    )
}